<template>
  <div>
    <section class="flex">
      <div style="width: 100px;" class="flexnone">
        <Tabs >
          <TabPane label="回款率"></TabPane>
        </Tabs>
      </div>
      <div>
        <search-list @getdata="getData"></search-list>
      </div>
    </section>
    <section>
      <table-list
        title="" :columns="columns" :data="data"
        :loading="loading"
        :total="total"
        :current="current"
        @change-page="changePage"
      >
      </table-list>
    </section>

  </div>
</template>

<script>
  import SearchList from '../../components/SearchList'
  import TableList from "components/TableList/index";
  import {findReturnRateList} from "../../../../api/reporter";
  import {getProjects} from "../../../../api/common";
  import {formatDateTime} from "../../../../utils/format";


  export default {
    name: "ReturnRate",
    components:{
      SearchList,
      TableList

    },
    created(){
      // this.init()
    },
    data(){
      return {
        columns:[
          {
            type:'index',
            title:'排名',
            align: 'center',
            width:70,

          },
          {
            title: '项目名称',
            key: 'projectName',
            align: 'center',
            width:170,
          },
          {
            title: '应收合同',
            key: 'receivableContractNum',
            align: 'center',
          },
          {
            title: '已收合同',
            key: 'receivedContractNum',
            align: 'center',
          },
          {
            title: '合同回款率',
            key: 'contractReturnRate',
            align: 'center',
            sortable: true,
            render:(h,params)=>{
              return h('span',{},(params.row['contractReturnRate']*100).toFixed(2)+'%')
            }
          },
          {
            title: '应收金额',
            key: 'receivableBillAmount',
            align: 'center',
          },
          {
            title: '已收金额',
            key: 'receivedBillAmount',
            align: 'center',
          },
          {
            title: '金额回款率',
            key: 'billReturnRate',
            align: 'center',
            sortable: true,
            render:(h,params)=>{
              return h('span',{},(params.row['billReturnRate']*100).toFixed(2)+'%')
            }
          },
        ],
        data:[],
        loading:false,
        current:1,
        total:0,
        searchData: null,
        page:1

      }
    },
    methods:{
      init() {
        let ret = {
          projectFids: [],
          type: 0,
          startTime: '',
          endTime: '',
          page: 1,
          limit: 10
        }
        let p1 = getProjects().then(res => {
          if (!res.data) {
            return
          }
          res.data.length > 0 && (ret.projectFids = [res.data[0].value])
        }).catch(error => {
        }).finally(() => {
          let date = new Date()
          let year = date.getFullYear()
          let month = date.getMonth()
          let day = date.getDate()
          ret.startTime = formatDateTime(new Date(year, month, day - 7), false)
          ret.endTime = formatDateTime(new Date(year, month, day - 1), false)
          this.searchData = ret

          this.findReturnRateList()

        })
      },
      findReturnRateList(){
        let params={
          ...this.searchData,
          page:this.page,
          limit:10
        }
        findReturnRateList(params).then(res=>{
          if(!res.data){
            return
          }
          this.data=res.data.list
          this.total=res.data.total
        }).catch(error=>{

        })
      },
      getData(params){
        this.current=1
        this.page=1
        this.searchData=params
        this.findReturnRateList()

      },
      changePage(n){
        this.current = n;
        this.page = n
        this.findReturnRateList()

      }
    }
  }
</script>

<style scoped>

</style>
